// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorNotFound_root__Jv_Aj","linksContainer":"ErrorNotFound_linksContainer__MZTiy","links":"ErrorNotFound_links__W2rMv"};